import { Injectable, inject } from "@angular/core";
import { PfmV2Service } from "../../shared/services/base/pfm-v2.service";
import { Observable } from "rxjs";

@Injectable()
export class UserPreferencesService {
  private apiV2Manager = inject(PfmV2Service);
  private urls = {
    getUserPrefConfig: () => `user_preferences/`,
    postUserPrefConfig: () => `user_preferences/create_update_preference/`
  }
  constructor() {}

  public getUserPersonalizationDataConfig(
    companyId: string,
    budgetId: string,
    area: string,
    personalizationKeys: string[]
  ): Observable<any> {
    return this.apiV2Manager.get(this.urls.getUserPrefConfig(), {
      "company": companyId,
      "budget": budgetId,
      "area": area,
      "personalization_keys": personalizationKeys.join(",")
    });
  }

  public postUserPersonalizationDataConfig(
    companyId: string,
    budgetId: string,
    area: string,
    personalizationKey: string,
    personalizationData: any,
    module: string = undefined
  ): Observable<any> {
    const requestData = {
      "company": companyId,
      "budget": budgetId,
      "area": area,
      "personalization_key": personalizationKey,
      "personalization_data": personalizationData
    }
    module ? requestData["module"] = module : null;
    return this.apiV2Manager.post(this.urls.postUserPrefConfig(), requestData);
  }
}
